import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const FRESHCHAT_SCRIPT_ID = 'freshchat-messenger-script';
const FRESHCHAT_STYLE_ID = 'freshchat-fullscreen-style';

const FreshchatFrame = () => {
  const user = useSelector((store) => store?.user);
  const isMounted = useRef(false);
	useEffect(() => {
		if (isMounted.current) return;
   	 	isMounted.current = true;
		
		window.fcWidgetMessengerConfig = {
			locale: 'id',
			open: false,
			config: {
				fullscreen: true,
				showFAQOnOpen: false,
				launcher: { hide: true },
				headerProperty: {
					hideChatButton: true,
					appName: 'UFOOD',
				},
			},
		};

		if (!document.getElementById(FRESHCHAT_STYLE_ID)) {
			const style = document.createElement('style');
			style.id = FRESHCHAT_STYLE_ID;
			style.innerHTML = `
				#fc_frame {
					z-index: 2147483647 !important;
				}
				#fc_frame.h-full {
					width: 100% !important;
					height: 100% !important;
					top: 0 !important;
					left: 0 !important;
					right: 0 !important;
					bottom: 0 !important;
				}
			`;
			document.head.appendChild(style);
		}

		if (!document.getElementById(FRESHCHAT_SCRIPT_ID)) {
			const script = document.createElement('script');
			script.id = FRESHCHAT_SCRIPT_ID;
			script.src = '//fw-cdn.com/8970553/3377318.js';
			script.async = true;
			script.setAttribute('chat', 'true');
			script.setAttribute('widgetId', '77214df4-9c6b-4567-9416-fa75cb88b57c');

			script.onload = () => {
				const wait = setInterval(() => {
					if (window.fcWidget?.isLoaded?.()) {
						window?.fcWidget?.user?.setFirstName(user?.firstName ?? user?.lastName ?? '');
						window?.fcWidget?.user?.setEmail(user?.email ?? '');
						window?.fcWidget?.user?.setProperties({ ...user });

						clearInterval(wait);
					}
				}, 1000);
			};

			document.body.appendChild(script);
		}
		return () => {
			window.fcWidget?.close();
		};
	}, []);

	return null;
};

export default FreshchatFrame;
